// Order On Date
var currentDate = new Date();

var orderDateElement = document.getElementById("orderDate");
orderDateElement.textContent = currentDate.toLocaleDateString('en', { day: 'numeric', month: 'short'  });;

// Shipped Date
let min = parseInt(document.getElementById('minimum_time').value, 10);
currentDate.setDate(currentDate.getDate() + min); 
var futureDate = new Date(currentDate);
futureDate.setDate(currentDate.getDate() + min); 
 
var startDate = currentDate.toLocaleDateString('en', { day: 'numeric', month: 'short'  });
var endDate = futureDate.toLocaleDateString('en', { day: 'numeric', month: 'short' });
 
var shipDateElement = document.getElementById("readyDate");
shipDateElement.textContent = startDate + ' - ' + endDate;
 
// Delivered Date
let newMin = 15 + min;
var currentDateSecond = new Date();
currentDateSecond.setDate(currentDateSecond.getDate() + newMin); 
 
var startDateSecond = currentDateSecond.toLocaleDateString('en', { day: 'numeric', month: 'short' });
 
// Calculate the end date in the second block
var futureDateSecond = new Date(currentDateSecond);
futureDateSecond.setDate(currentDateSecond.getDate() + min);
 
var endDateSecond = futureDateSecond.toLocaleDateString('en', { day: 'numeric', month: 'short' });
 
// Update the delivery date elements
var deliveryDateElement = document.getElementById("deliveryDate");
deliveryDateElement.textContent = startDateSecond + ' - ' + endDateSecond;
 